import type { UseQueryResult } from 'react-query/types/react/types';

import type { ItemTypeSelector } from 'hb-builder/utils/dynamicSelectorsHelpers';
import type { Category } from 'hb-react/backoffice/components/CategoriesList/v2/types';
import { useGetDiscussionsCategories } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicCategories/useGetDiscussionsCategories';
import { useGetEventsCategories } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicCategories/useGetEventsCategories';
import { useGetNewsCategories } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicCategories/useGetNewsCategories';
import { useGetPostCategories } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicCategories/useGetPostCategories';
import { useGetTopicsCategories } from 'hb-react/backoffice/requests/dynamicComponents/useGetDynamicCategories/useGetTopicsCategories';

export const useGetDynamicCategories = ({
  type,
  enabled = true,
}: {
  type: ItemTypeSelector;
  enabled?: boolean;
}): UseQueryResult<Category[]> =>
  ({
    discussions: useGetDiscussionsCategories({
      enabled: enabled && type === 'discussions',
    }),
    events: useGetEventsCategories({
      enabled: enabled && type === 'events',
    }),
    news: useGetNewsCategories({
      enabled: enabled && type === 'news',
    }),
    posts: useGetPostCategories({
      enabled: enabled && type === 'posts',
    }),
    topics: useGetTopicsCategories({
      enabled: enabled && type === 'topics',
    }),
  }?.[type] || { data: undefined, isLoading: false, isError: false });
